import React from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  makeStyles,
  useMediaQuery,
} from "@material-ui/core";
import CancelOutlinedIcon from "@material-ui/icons/CancelOutlined";
import SignaturePad from "react-signature-pad-wrapper";

import { Button } from "react-admin";

import { base64ToBlob } from "../../../utils/fileUtils";
import { CancelIcon, CheckIcon, ClearIcon } from "../../../components/common/iconography";

// Every signature pad in the product -- manager inbound/outbound forms and both
// crew flows -- renders through this dialog, so the drawing area is styled here
// and nowhere else.
const useStyles = makeStyles({
  sigContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  sigPadMobile: {
    height: 240,
    border: "1px solid grey",
  },
  sigPad: {
    height: 380,
    border: "1px solid grey",
  },
});

export const SignatureDialog = ({
  open,
  handleClose,
  addSignature,
  invalidSignatureMessage,
  clearSignature,
  signatureRef,
  signatureImg,
  saving,
}) => {
  const classes = useStyles();

  const handleSave = () => {
    if (signatureRef.current) {
      const signatureDataUrl = signatureRef.current.toDataURL();
      const signatureBinaryImage64Img = signatureDataUrl.split(",")[1];
      const signatureBinaryImage = base64ToBlob(
        signatureBinaryImage64Img,
        "image/png"
      );
      addSignature({ signatureBinaryImage, signatureDataUrl });
    }
  };

  const handleClear = () => {
    if (signatureRef.current) {
      signatureRef.current.clear();
      clearSignature();
    }
  };

  const isSmall = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const setImage = (ref) => {
    // fromDataURL() flips the pad's internal isEmpty flag to false whatever it is
    // handed, so a missing image would make a blank pad report as signed.
    if (ref && signatureImg) {
      ref.fromDataURL(signatureImg);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xl"
      style={isSmall ? {} : { margin: 32 }}
      fullWidth
      disableBackdropClick
    >
      <Box
        component="span"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        m={2}
      >
        <Typography variant="h6">Capture Signature</Typography>
        <CancelOutlinedIcon fontSize="large" onClick={handleClose} />
      </Box>
      <DialogContent>
        <DialogContentText>
          <div className={classes.sigContainer}>
            <SignaturePad
              ref={(ref) => {
                setImage(ref);
                signatureRef.current = ref;
              }}
              canvasProps={{
                className: isSmall ? classes.sigPadMobile : classes.sigPad,
              }}
              options={{
                minWidth: 1,
                maxWidth: 3,
                penColor: "rgb(0, 0, 0)",
              }}
            />
            <div>
              <Typography color="error">{invalidSignatureMessage}</Typography>
            </div>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          label="Cancel"
          disabled={saving}
          onClick={handleClose}
          color="default"
        >
          <CancelIcon />
        </Button>
        <Button
          label="Clear"
          disabled={saving}
          onClick={handleClear}
          color="default"
        >
          <ClearIcon />
        </Button>
        <Button
          label="Save"
          disabled={saving}
          onClick={handleSave}
          color="primary"
          autoFocus
        >
          <CheckIcon />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
